import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ addressIds, stepId }) => {
  return request.put(
    'Acceptance/mass_change_step_address_life_cycle',
    { addressIds, stepId },
    undefined,
    'Error',
    undefined,
    undefined,
    undefined,
    true
  );
};

export const useRoomListStepMutation = (options) => {
  return useMutation(mutationFn, options);
};
